$(document).ready(() =>
{
    const tables = [];

    window.applyDataTables = () => {
        const $tables = jQuery('.sortable-table');
        const $tablesNone = jQuery('.sortable-table-none');

        for(let i = 0; i < tables.length; i++){
            tables[ i ].destroy();
        }

        tables.length = 0;

        $tables.each((index, element) => {
            const $element = $(element);

            const table = $element.DataTable({
                "searching": false,
                "info": false,
                "paging": false
            });
            tables.push(table);
        })

        $tablesNone.each((index, element) => {
            const $element = $(element);
            const table =  $element.DataTable(
                {
                    "searching": false,
                    "info": false,
                    "paging": false,
                    "order": [[ 0, "asc" ]]
                });
            tables.push(table);
        });
    }

    window.applyDataTables();

});

//$.fn.dataTableExt.sErrMode = 'throw';